var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumValidation = function SvgNumValidation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "num-validation_svg2__a",
    x1: 35.94,
    x2: 203.65,
    y1: 230.35,
    y2: 54.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#num-validation_svg2__a",
    id: "num-validation_svg2__b",
    x1: -5.36,
    x2: 162.36,
    y1: 191.04,
    y2: 14.85
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#num-validation_svg2__a",
    id: "num-validation_svg2__c",
    x1: -45,
    x2: 122.72,
    y1: 153.31,
    y2: -22.88
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#num-validation_svg2__a",
    id: "num-validation_svg2__d",
    x1: 11.28,
    x2: 179,
    y1: 206.88,
    y2: 30.69
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#num-validation_svg2__a",
    id: "num-validation_svg2__e",
    x1: 6.49,
    x2: 174.21,
    y1: 202.32,
    y2: 26.13
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M74.34 179.31c-2.07 0-3.45 1.38-3.45 3.45s1.38 3.45 3.45 3.45h13.79c2.07 0 3.45-1.38 3.45-3.45s-1.38-3.45-3.45-3.45z",
    style: {
      fill: "url(#num-validation_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.97 20.34c0 2.07 1.38 3.45 3.45 3.45s3.45-1.38 3.45-3.45C139.87 9.31 130.56 0 119.53 0H42.97C31.94 0 22.63 9.31 22.63 20.34v159.31c0 11.38 9.31 20.34 20.34 20.34h76.55c11.38 0 20.34-9.31 20.34-20.34v-48.62c0-2.07-1.38-3.45-3.45-3.45s-3.45 1.38-3.45 3.45v48.62c0 7.59-6.21 13.45-13.45 13.45H42.97c-7.59 0-13.45-6.21-13.45-13.45V20.34c0-7.24 6.21-13.45 13.45-13.45h76.55c7.24 0 13.45 6.21 13.45 13.45",
    style: {
      strokeWidth: 0,
      fill: "url(#num-validation_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.21 20.69c0-2.07-1.38-3.45-3.45-3.45H65.73c-2.07 0-3.45 1.38-3.45 3.45s1.38 3.45 3.45 3.45h31.03c2.07 0 3.45-1.38 3.45-3.45",
    style: {
      strokeWidth: 0,
      fill: "url(#num-validation_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.59 62.07c-1.72.69-2.76 2.41-2.41 4.14 5.17 18.28-5.52 37.24-23.79 42.41-18.28 5.17-37.24-5.52-42.41-23.79-5.17-18.28 5.52-37.24 23.79-42.41 2.76-.69 6.21-1.03 9.31-1.03 4.83 0 10 1.03 14.48 3.1 1.72.69 3.79 0 4.48-1.72s0-3.79-1.72-4.48c-20.69-9.66-45.52-.34-54.83 20.34-9.31 20.69-.34 45.17 20.34 54.83 20.69 9.66 45.17.34 54.83-20.34 4.14-8.97 4.83-18.97 2.07-28.62-.34-1.72-2.41-2.76-4.14-2.41Z",
    style: {
      strokeWidth: 0,
      fill: "url(#num-validation_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.76 54.48-30.34 30.34-11.38-11.38c-1.38-1.38-3.45-1.38-4.83 0s-1.38 3.45 0 4.83L124 92.06c1.38 1.38 3.45 1.38 4.83 0l32.76-32.76c1.38-1.38 1.38-3.45 0-4.83s-3.45-1.38-4.83 0Z",
    style: {
      strokeWidth: 0,
      fill: "url(#num-validation_svg2__e)"
    }
  }));
};
export default SvgNumValidation;